/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useToastContainer } from "react-toastify";

import Toast from "./Toast";

export enum ToastPosition {
  topRight = "top-right",
  topCenter = "top-center",
  topLeft = "top-left",
  bottomRight = "bottom-right",
  bottomCenter = "bottom-center",
  bottomLeft = "bottom-left",
}

const positionMapping: Record<ToastPosition, object> = {
  [ToastPosition.topRight]: {
    top: 12,
    right: 12,
    alignItems: "flex-end",
  },
  [ToastPosition.topCenter]: {
    top: 12,
    left: "50%",
    transform: "translateX(-50%)",
    alignItems: "center",
  },
  [ToastPosition.topLeft]: {
    top: 12,
    left: 12,
    alignItems: "flex-start",
  },
  [ToastPosition.bottomRight]: {
    bottom: 12,
    right: 12,
    alignItems: "flex-end",
  },
  [ToastPosition.bottomCenter]: {
    bottom: 12,
    left: "50%",
    transform: "translateX(-50%)",
    alignItems: "center",
  },
  [ToastPosition.bottomLeft]: {
    bottom: 12,
    left: 12,
    alignItems: "flex-start",
  },
};

/** Drop in replacement for the default react-toastify container */
const ToastContainer = (props) => {
  const { getToastToRender } = useToastContainer(props);

  return (
    <div>
      {getToastToRender((position, toastList) => (
        <div
          className="flex flex-col gap-y-3"
          style={{
            position: "fixed",
            zIndex: 9999,
            ...positionMapping[position ?? "top-right"],
          }}
        >
          {toastList.map(({ content, ...options }) => (
            // @ts-expect-error Some differing props and enums vs unions
            <Toast {...options.props}>
              {typeof content === "function" ? content({
                closeToast: options.props.closeToast,
                toastProps: options.props,
                data: options.props.data,
              }) : content}
            </Toast>
          ))}
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
